import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent } from "@mui/material";
import { useCallback } from "react";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { DialogFooter } from "../../components/DialogFooter";
import { DocumentSubmissionInReviewBottomSheetContent } from "./InReviewContent";

interface DocumentSubmissionInReviewBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentSubmissionInReviewBottomSheet(
  props: DocumentSubmissionInReviewBottomSheetProps
) {
  const { modalState } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={<DialogFooter orientation="vertical" />}
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <DocumentSubmissionInReviewBottomSheetContent />
      </DialogContent>
    </BottomSheet>
  );
}
